import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useTranslation } from 'react-i18next';
import { StatsPageInfo, StatCard } from '~/components/Shared/StatsPageInfo/StatsPageInfo';

interface FeedbacksStatistics {
  total: number | null;
  created: number | null;
  in_progress: number | null;
  done: number | null;
  closed: number | null;
}

interface Props {
  statusFilter: string;
  setStatusFilter: (value: string) => void;
}

const AllIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

const CreatedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="16"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
);

const InProgressIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

const DoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

const ClosedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);

export const FeedbacksPageInfo = ({ statusFilter, setStatusFilter }: Props) => {
  const { t } = useTranslation();

  const { data: stats } = useQuery<FeedbacksStatistics>({
    queryFn: async () => {
      const response = await instance.get('admin/feedback-statistics');
      return response.data;
    },
    queryKey: ['feedback-statistics'],
  });

  const cards: StatCard[] = [
    { value: '', label: t('total'), count: stats?.total, color: 'purple', icon: <AllIcon /> },
    { value: '1', label: t('created'), count: stats?.created, color: 'purple', icon: <CreatedIcon /> },
    { value: '2', label: t('in_progress'), count: stats?.in_progress, color: 'orange', icon: <InProgressIcon /> },
    { value: '3', label: t('done'), count: stats?.done, color: 'green', icon: <DoneIcon /> },
    { value: '4', label: t('closed'), count: stats?.closed, color: 'gray', icon: <ClosedIcon /> },
  ];

  return (
    <StatsPageInfo
      activeStatus={statusFilter}
      onStatusChange={setStatusFilter}
      cards={cards}
    />
  );
};
